import React from "react";
import "./loader.css";

export default function LoadingSpinner() {
  return (
      <>
        <section className="spinner">
            <div class="loader"></div>
        </section>
    </>
  );
}